@if (securityService.loggedIn()) {
    <app-toolbar></app-toolbar>
    <mat-divider/>
    <app-error-message-panel></app-error-message-panel>
    <main cdkScrollable>
        <router-outlet/>
    </main>
}
